import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateChiller } from '../../redux/ac_central/chiller_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.chiller.isDuplicating,
  errorMessage: state.ac.chiller.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateChiller(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/ChillerDuplicateModal.js